


































































































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { SwIcon } from '../sw-icon';
import { CircleMenuItem } from './types';
import { drag, DragPosition } from '../drag-dir';

@Component({
  components: {
    SwIcon,
  },
  directives: {
    drag,
  },
})
export default class SwCircleMenu extends SwExtendedVue {
  @Prop({ required: true, type: Array })
  menuItems: CircleMenuItem[];

  @Prop({ type: Object, default() { return {}; } })
  initPosition: {left?: number, top?: number, bottom?: number, right?: number};

  menuId: string = `circle-menu-${Math.floor(Math.random() * 1000000)}`;

  opened: boolean = false;

  highlightedMenuItemId: string | null = null;

  position: {left?: number, top?: number, bottom?: number, right?: number} = this.initPosition;

  get wrapperStyle() {
    if (this.position) {
      return {
        left: this.position.left !== undefined ? `${this.position.left}px` : undefined,
        top: this.position.top !== undefined ? `${this.position.top}px` : undefined,
        bottom: this.position.bottom !== undefined ? `${this.position.bottom}px` : undefined,
        right: this.position.right !== undefined ? `${this.position.right}px` : undefined,
      };
    }
    return {};
  }

  calcItemStyle(item: CircleMenuItem) {
    const index = this.menuItems.indexOf(item);
    const number = this.menuItems.length;
    return {
      transform: this.opened ? `rotate(${360 / number * index}deg) translateY(${-80 - 30}px)` : undefined,
    };
  }

  calcItemContentStyle(item: CircleMenuItem) {
    const index = this.menuItems.indexOf(item);
    const number = this.menuItems.length;
    return {
      transform: `rotate(${-360 / number * index}deg)`,
    };
  }

  public toggle(opened?: boolean) {
    if (opened !== undefined) {
      this.opened = opened;
    } else {
      this.opened = !this.opened;
    }
  }

  public highlightItem(menuItemId: string | null, doHighlight: boolean = true) {
    if (menuItemId === null) {
      this.highlightedMenuItemId = null;
    }
    if (doHighlight) {
      this.highlightedMenuItemId = menuItemId;
    } else if (this.highlightedMenuItemId === menuItemId) {
      this.highlightedMenuItemId = null;
    }
  }

  @Watch('opened')
  onToggle() {
    this.$emit('toggle', this.opened);
  }

  onClickItem(item: CircleMenuItem) {
    this.$emit('click-item', item);
  }

  dragPositioning(toClientPos: DragPosition) {
    const op = (this.$el as HTMLElement).offsetParent;
    if (!op) { return; }
    const opRect = op.getBoundingClientRect();
    this.position = {
      left: toClientPos.x - opRect.left,
      top: toClientPos.y - opRect.top,
    };
  }
}
